import React, { useState } from "react";
import "./balance-card.scss";
import { currencyFormat } from "../../../utils/helpers";
import { ClipLoader } from "react-spinners";
interface BalanceCardProps {
  balance: number;
  currency?: string;
  onWithdraw: () => void;
  isLoading: boolean;
  balanceError?: Error | null;
}

const BalanceCard: React.FC<BalanceCardProps> = ({
  isLoading,
  balance,
  currency = "$",
  onWithdraw,
  balanceError,
}) => {
  const [viewState, setViewState] = useState(false);
  return (
    <div className="balance-card">
      <div className="card-content">
        <div className="balHead">
          <h3>Total Balance</h3>
          <div onClick={() => setViewState(!viewState)} className="show-toggle" data-test="toogle">
            {viewState ? (
              <i className="fa-solid fa-eye-slash"></i>
            ) : (
              <i className="fa-solid fa-eye"></i>
            )}
          </div>
        </div>

        {balanceError ? (
          <p style={{ color: "red", marginBottom: "20px", fontSize: "1rem" }}>
            Balance unavailable
          </p>
        ) : (
          <>
            {!isLoading ? (
              <>
                {viewState ? (
                  <p className="balance-amount">{currencyFormat(balance)} </p>
                ) : (
                  <p className="balance-amount">....</p>
                )}
              </>
            ) : (
              <p className="balance-amount">
                <ClipLoader />
              </p>
            )}
          </>
        )}

        {/* )} */}

        {/* Withdraw Button */}
        <button className="withdraw-button" onClick={onWithdraw}>
          Withdraw
        </button>
      </div>
    </div>
  );
};

export default BalanceCard;
